import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0996241c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "check-box" };
const _hoisted_2 = /*#__PURE__*/ _createTextVNode(" 仅支持字母、数字、特殊字符（空格除外）。 ");
const _hoisted_3 = /*#__PURE__*/ _createTextVNode(" 长度为 8 到 20 个字符。 ");
const _hoisted_4 = /*#__PURE__*/ _createTextVNode(" 必须包含至少两种类型的字符：字母、数字、特殊字符。 ");
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "popper-arrow" }, null, -1));
import { checkPassword1, checkPassword2, checkPassword3 } from "@/utils";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    name: 'index',
    props: {
        value: { default: "" }
    },
    setup(__props) {
        const props = __props;
        const check1 = computed(() => checkPassword1(props.value) ? "success" : "error");
        const check2 = computed(() => checkPassword2(props.value) ? "success" : "error");
        const check3 = computed(() => checkPassword3(props.value) ? "success" : "error");
        return (_ctx, _cache) => {
            const _component_svg_icon = _resolveComponent("svg-icon");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", null, [
                    _createVNode(_component_svg_icon, {
                        "icon-class": _unref(check1),
                        "class-name": _unref(check1) + '-icon'
                    }, null, 8, ["icon-class", "class-name"]),
                    _hoisted_2
                ]),
                _createElementVNode("div", null, [
                    _createVNode(_component_svg_icon, {
                        "icon-class": _unref(check2),
                        "class-name": _unref(check2) + '-icon'
                    }, null, 8, ["icon-class", "class-name"]),
                    _hoisted_3
                ]),
                _createElementVNode("div", null, [
                    _createVNode(_component_svg_icon, {
                        "icon-class": _unref(check3),
                        "class-name": _unref(check3) + '-icon'
                    }, null, 8, ["icon-class", "class-name"]),
                    _hoisted_4
                ]),
                _hoisted_5
            ]));
        };
    }
});
